import { getAllowedGids } from '@cc/utils';

(function () {
  function filterSection(container) {
    const gids = getAllowedGids();
    if (!gids) return;

    const items = container.querySelectorAll('[data-cc-locations]');
    if (!items.length) return;

    let visibleCount = 0;

    items.forEach((item) => {
      const locations = item.dataset.ccLocations;
      const unavailable = !locations || !locations.split(',').some((loc) => gids.includes(loc.trim()));
      item.classList.toggle('cc-hidden', unavailable);
      if (!unavailable) visibleCount++;
    });

    container.querySelectorAll('.swiper-initialized').forEach((el) => {
      if (el.swiper) {
        el.swiper.update();
      }
    });

    const section = container.closest('section') || container.closest('.shopify-section');
    if (section) {
      section.classList.toggle('!hidden', visibleCount === 0);
    }
  }

  function filterAll() {
    document
      .querySelectorAll(
        'product-recommendations, .featured-products, [data-cc-section-filter], .collection',
      )
      .forEach(filterSection);
  }

  let filterTimer = null;
  function debouncedFilterAll() {
    clearTimeout(filterTimer);
    filterTimer = setTimeout(filterAll, 50);
  }

  document.addEventListener('DOMContentLoaded', filterAll);
  document.addEventListener('recommended-products-loaded', () => {
    requestAnimationFrame(filterAll);
  });
  document.addEventListener('related-products-loaded', () => {
    requestAnimationFrame(filterAll);
  });
  document.addEventListener('product-grid-updated', filterAll);

  window.addEventListener('zippy:cc-store-selector:change', debouncedFilterAll);
})();
